import React from "react";
import { Draggable } from "@hello-pangea/dnd";
import { Task, Project, TaskStatus } from "../../types/Work";
import { TaskCard } from "./TaskCard";

interface SortableTaskCardProps {
  task: Task;
  index: number;
  projects?: Project[];
  onEdit: (task: Task) => void;
  onDelete: (taskId: string) => void;
  onToggleTimer: (task: Task) => void;
  onStatusChange: (taskId: string, status: TaskStatus) => void;
}

export const SortableTaskCard: React.FC<SortableTaskCardProps> = ({
  task,
  index,
  projects,
  onEdit,
  onDelete,
  onToggleTimer,
  onStatusChange,
}) => {
  return (
    <Draggable draggableId={task.id} index={index}>
      {(provided, snapshot) => (
        <div
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          className={`task-card-wrapper ${
            snapshot.isDragging ? "is-dragging" : ""
          }`}
          style={provided.draggableProps.style}
        >
          <TaskCard
            task={task}
            projects={projects}
            onEdit={onEdit}
            onDelete={onDelete}
            onToggleTimer={onToggleTimer}
            onStatusChange={onStatusChange}
          />
        </div>
      )}
    </Draggable>
  );
};
